import React from "react";
import { ColumnDef } from "@tanstack/react-table";
import { formatDateString } from "../../../../utils/dates";
import { AccountAPIKey } from "./__queries__/apiKeyQueries";
import { ActionButton } from "./ActionButton";

export const useColumns = ({
  existingNames,
  refetch,
}: {
  existingNames: Array<string>;
  refetch: () => void;
}): Array<ColumnDef<AccountAPIKey>> => {
  return [
    {
      accessorKey: "name",
      id: "name",
      header: "Name",
      size: 200,
      cell: ({ row }) => row.original.name,
    },
    {
      accessorKey: "createdAt",
      id: "createdAt",
      header: "Created",
      size: 200,
      cell: ({ row }) =>
        formatDateString({
          format: "MMMM D, YYYY",
          dateString: row.original.createdAt,
        }),
    },
    {
      id: "actions",
      size: 150,
      maxSize: 150,
      cell: ({ row }) => (
        <ActionButton
          apiKey={row.original}
          existingNames={existingNames}
          refetch={refetch}
        />
      ),
      meta: { className: "actions-cell" },
    },
  ];
};
